import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { glossary } from "@/mocks/community";

export default function Glossary() {
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    const key = keyword.trim();
    if (!key) return glossary;
    return glossary.filter(
      (item) => item.term.includes(key) || item.desc.includes(key) || item.category.includes(key)
    );
  }, [keyword]);

  return (
    <section id="glossary" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="DICTIONARY · 瓜田词典"
          title="吃瓜必备黑话速查"
          desc="看不懂评论区在说什么？先在这里补补课。收录常见说法与辨别思路，帮你分清楚「传闻」和「实锤」。"
        />
        <label className="relative w-full md:w-72 shrink-0">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
          <input
            type="text"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索黑话，如：塌房 / 实锤"
            className="w-full bg-background-50 border border-background-300 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200 rounded-md pl-9 pr-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400"
          />
        </label>
      </div>

      {filtered.length > 0 ? (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((item) => (
            <article
              key={item.term}
              className="bg-background-50 border border-background-200 rounded-lg p-5 hover:border-accent-400 transition-colors"
            >
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-label text-lg text-foreground-950">{item.term}</h3>
                <span className="text-xs text-accent-800 bg-accent-100 px-2 py-0.5 rounded-md shrink-0">
                  {item.category}
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      ) : (
        <div className="mt-8 bg-background-50 border border-background-200 rounded-lg p-10 text-center">
          <i className="ri-emotion-normal-line text-3xl text-foreground-300" />
          <p className="mt-3 text-sm text-foreground-500">
            没有找到「{keyword}」，换个词试试，比如「实锤」「考古」。
          </p>
        </div>
      )}
    </section>
  );
}